import { render, staticRenderFns } from "./BackupRestoreLogTable.vue?vue&type=template&id=60efc1f4&"
import script from "./BackupRestoreLogTable.vue?vue&type=script&lang=js&"
export * from "./BackupRestoreLogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports